import { FC } from 'react';
import { useIntl } from 'react-intl';

import { useAnalytics } from '@/hooks/analytics/useAnalytics';
import useDiscountedPricing from '@/hooks/api/useDiscountedPricing';
import { useIsMobile } from '@/hooks/layout/useIsMobile';
import { currencyStringFromCents } from '@/utils/helpers';

import { CoveredLivesCount, NavigateTo } from '../../types';
import messages from './messages';
import { EditButton, EditCoveredLivesText, PlanPreviewWrapper, PriceTagIcon } from './styles';

interface PlanPreviewProps {
	coveredLives: CoveredLivesCount;
	displayPrice: boolean;
	navigateTo: NavigateTo;
	activePage: string;
}

const PlanPreview: FC<PlanPreviewProps> = ({ coveredLives, navigateTo, activePage }) => {
	const [isMobile] = useIsMobile();
	const { formatMessage } = useIntl();

	const { totalCost } = useDiscountedPricing(coveredLives);
	const { logEvent } = useAnalytics();

	return (
		<PlanPreviewWrapper data-testid="self-serve-plan-preview-updated">
			{isMobile ? (
				<>
					<EditCoveredLivesText>{formatMessage(messages.planPreviewTaglineMobile)}</EditCoveredLivesText>
					<EditCoveredLivesText isTextBody={true}>
						{formatMessage(messages.planPreviewCopyMobile, {
							coveredLivesCount: coveredLives,
							annualPrice: currencyStringFromCents(totalCost),
						})}
					</EditCoveredLivesText>
				</>
			) : (
				<>
					<PriceTagIcon data-testid="price-tag-icon" />
					<EditCoveredLivesText>
						{formatMessage(messages.planPreviewCopy, {
							coveredLivesCount: coveredLives,
							annualPrice: currencyStringFromCents(totalCost),
						})}
					</EditCoveredLivesText>
				</>
			)}
			<EditButton
				onClick={() => {
					logEvent('Teams : Edit Covered Lives', {
						action: 'click',
						location: activePage,
						variant: '7-16-24',
					});
					navigateTo('coveredLives');
				}}
			>
				{formatMessage(messages.editCoveredLivesLink)}
			</EditButton>
		</PlanPreviewWrapper>
	);
};

export default PlanPreview;
